<template>
    <v-app-bar
      app
      color="white"
      light
    >
      <div class="d-flex align-center">
        <router-link :to="{name:'home'}">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="~@/assets/werner-main-logo.svg"
          transition="scale-transition"
          width="100"
        />
        </router-link>
        </div>

      <v-spacer></v-spacer>

        <div class="align-center hidden-sm-and-down">
        <h1 class="headline">KI-Trainer Anmeldung</h1>
        </div>


      <v-spacer></v-spacer>
        <v-btn to="/signin"
        v-if="!loggedIn"
        text
      >
      <span class="mr-2">Login</span>
        <v-icon>mdi-login</v-icon>
      </v-btn>
      <v-btn to="/logout"
        v-if="loggedIn"
        text
      >
      <span class="mr-2">Logout</span>
        <v-icon>mdi-leave</v-icon>
      </v-btn>
    </v-app-bar>
</template>

<script>
import auth from "../auth";
export default {
  name: "Navbar",
  data() {
    return {
      loggedIn: auth.loggedIn(),
      activeView: ""
    };
  },
  created() {
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
    };
  },
}
</script>

<style>
.hidden {
  visibility:hidden;
}
</style>
